export default __webpack_public_path__ + "static/media/gratitude.26bcdffe.svg";